WB.DataServices = WB.DataServices || {};
WB.DataServices.Locations = function ($http, $q, _Config) {

    var _this = this;

    this.LocationsUrl = _Config.BaseURLs.Locations.Prod;

    this.CreateFavoriteLocation = function(favoriteLocation) {
        return $http.post('/api/favorite-locations', favoriteLocation).then(function (data) {
            favoriteLocation.Id = data.data.Id;
        });
    };

    this.CreateUserRecentSearchLocation=function(lastSearchedLocation) {
        return $http.post('/api/favorite-locations/StoreLast6SearchLocaions', lastSearchedLocation).then(function (data) {
            lastSearchedLocation.Id = data.data.Id;
        });
    };

    this.GetUserRecentSearchLocation=function() {

        return $q(function(resolve, reject) {
            $http({
                url: '/api/favorite-locations/GetSearchLocation',
                method: 'GET'
            }).success(resolve);
        });
    };

    this.UpdateFavoriteLocation = function(favoriteLocation) {
        return $http.put('/api/favorite-locations/' + favoriteLocation.Id, favoriteLocation);
    };

    this.DeleteFavoriteLocation = function(favoriteLocation) {
        return $http.delete('/api/favorite-locations/' + favoriteLocation.Id+','+favoriteLocation.Location.Locality.Latitude+','+ favoriteLocation.Location.Locality.Longitude);
    };

    this.SearchLocalities = function(query) {
        return $q(function(resolve, reject) {
            $http({
                url: _this.LocationsUrl + '/data/locations/v3/location',
                method: 'GET',
                params: {
                    searchString: query,
                    maxresults: 10,
                    verbose: true
                },
                hmac: true
            })
                .success(function(localities) {
                    angular.forEach(localities, function(locality) {
                        locality.RouteString = locality.SlugName;
                        locality.Label = locality.DisplayCompositeName;
                    });

                    resolve(localities);
                });
        });
    };

    this.GetLocationForLatLng = function(lat, lng) {
        return $q(function(resolve, reject) {
            $http({
                method: 'GET',
                url: '/api/locations/latlng',
                params: {
                    lat: lat,
                    lng: lng
                }
            })
                .success(resolve)
                .error(function(data) {
                    reject(new Error('Unable to get location for lat/lng.'));
                });
        });
    };

    this.GetLocalityForLatLng = function(lat, lng) {
        return $q(function(resolve, reject) {
            $http({
                method: 'GET',
                url: '/api/localities',
                params: {
                    lat: lat,
                    lng: lng
                }
            })
                .success(resolve)
                .error(function(data) {
                    reject(new Error('Unable to get localities for lat/lng.'));
                });
        });
    };

    this.CreateLocationForQuery = function(query) {
        return $q(function(resolve, reject) {
            $http({
                method: 'POST',
                url: '/api/locations/query',
                data: { Query: query }
            }).success(resolve);
        });
    };

    this.UpdateActiveLocation = function (locationslug) {
        return $q(function (resolve, reject) {
            $http({
                method: 'GET',
                url: '/api/locations/updateActiveLocation',
                params: { 'locationSlug': locationslug }
            }).success(resolve);
        });
    };

    this.UpdateLocation = function(location) {
        return $q(function(resolve, reject) {
            $http.put('/api/locations/' + location.Id, location).success(resolve);
        });
    };

    this.GetStationsForLatLng = function(lat, lng) {
        return $q(function(resolve, reject) {
            $http({
                url: '/api/stations',
                method: 'GET',
                params: {
                    lat: lat,
                    lng: lng,
                    radius: 15.0
                }
            }).success(resolve);
        });
    };
};
WB.DataServices.Locations.$inject = ['$http', '$q', '_Config'];

WB.Core.service('LocationsDataService', WB.DataServices.Locations);
